import { createApi } from "@reduxjs/toolkit/query/react";

import { REQUEST_METHODS } from "@/constants/global-constants";
import { IWorkForceSettings } from "@/interfaces/workforce-settings.interface";
import { BaseWithAuth, getWorkspace } from "@/utils/helpers";

export const workforceSettingsApi = createApi({
  reducerPath: "workforceSettingsApi",
  baseQuery: BaseWithAuth(),
  tagTypes: ["workforceSettings"],
  endpoints: (builder) => ({
    getWorkforceSettings: builder.query<IWorkForceSettings, object>({
      query: () => ({
        url: `workspace/${getWorkspace()}/workforce/setting`,
      }),
      providesTags: ["workforceSettings"],
      transformResponse: (response: APIResponse<IWorkForceSettings>) =>
        response?.data,
    }),
    mutateWorkforceSettings: builder.mutation<
      object,
      { id?: string; method: REQUEST_METHODS; data: object }
    >({
      query: ({ data, method }) => ({
        url: `workspace/${getWorkspace()}/workforce/setting`,
        method,
        body: data,
      }),
      invalidatesTags: ["workforceSettings"],
    }),
  }),
});

export const {
  useGetWorkforceSettingsQuery,
  useMutateWorkforceSettingsMutation,
} = workforceSettingsApi;
